import qoalaStorage from '~/core/Storage';
import { parseIfJsonString } from '~/core/helper/JSONHelper';

export default {
  getListPromotion: state => state.promoData,
  searchDetailPromo: state =>
    qoalaStorage.getItem('detailPromo') ? parseIfJsonString(qoalaStorage.getItem('detailPromo')) : state.detailPromo,
  getSearchDetailListPromo: state => state.searchDetailPromo,
  getSearchCodePromotion: state => state.searchCodePromo,
  promoDetail: state => state.useCodePromo,
  removePromo: state => state.isCancel,
  getPromoProduct: state =>
    qoalaStorage.getItem('promoProduct') ? parseIfJsonString(qoalaStorage.getItem('promoProduct')) : state.promoProduct,
  getPromoCalculation: state =>
    qoalaStorage.getItem('promoCalculation')
      ? parseIfJsonString(qoalaStorage.getItem('promoCalculation'))
      : state.promoCalculation
};
